var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParisTransitIconsMtro5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "250px",
    height: "250px",
    viewBox: "0 0 283.46 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Paris transit icons - M\xE9tro Ligne 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#F28E42",
    cx: 141.73,
    cy: 141.73,
    r: 141.73
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#25303B",
    d: "M192.66 168.3c0-22.56-16.59-45.74-57.66-47.66-1.49 0-3.39-.21-4.25-.21l2.12-28.51h54V66.8H108l-6 78.09c4.91 0 14.91.21 23.42.21 27.65.43 34.89 15.33 34.89 26.18 0 17.66-14.67 24.69-26.37 24.69s-20.22-3.84-28.52-9.58L93.3 209.78c11.49 7 24.9 10.87 42.34 10.87 34.26 0 57-23.62 57-52.35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParisTransitIconsMtro5);
export default __webpack_public_path__ + "static/media/Paris_transit_icons_-_Métro_5.b68b4a881427d80fbfd5f59fc9a73936.svg";
export { ForwardRef as ReactComponent };